var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maintenance-overlay d-flex flex-column align-items-center justify-content-center text-center"},[_c('Loader'),_c('h4',{staticClass:"mt-4 mb-2"},[_vm._v("TalentFind is switching database")]),_c('p',{staticClass:"mb-0"},[_vm._v(" This takes under a minute - you'll then need to log in again. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }